import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { retryNon4xx } from "shared/api/query-retry";
import { aboutAdminApi } from "../../api/aboutAdminApi";
var key = function (collectionId) { return ["admin", "about", collectionId]; };
export var useAbout = function (collectionId) {
    return useQuery({
        queryKey: key(collectionId),
        queryFn: function () { return aboutAdminApi.get(collectionId); },
        enabled: !!collectionId,
        staleTime: 30000,
        retry: retryNon4xx,
    });
};
export var useSaveAbout = function (collectionId) {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (payload) {
            return aboutAdminApi.putAll(collectionId, payload);
        },
        onSuccess: function (data) { return qc.setQueryData(key(collectionId), data); },
    });
};
export var useSetAboutBlockImage = function (collectionId) {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (_a) {
            var n = _a.n, file = _a.file;
            return aboutAdminApi.setBlockImage(collectionId, n, file);
        },
        onSuccess: function (data) { return qc.setQueryData(key(collectionId), data); },
    });
};
export var useDeleteAboutBlockImage = function (collectionId) {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (n) { return aboutAdminApi.deleteBlockImage(collectionId, n); },
        onSuccess: function (data) { return qc.setQueryData(key(collectionId), data); },
    });
};
export var useSetAboutBlock5Slot = function (collectionId) {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (_a) {
            var slot = _a.slot, file = _a.file;
            return aboutAdminApi.setBlock5Slot(collectionId, slot, file);
        },
        onSuccess: function (data) { return qc.setQueryData(key(collectionId), data); },
    });
};
export var useDeleteAboutBlock5Slot = function (collectionId) {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (slot) {
            return aboutAdminApi.deleteBlock5Slot(collectionId, slot);
        },
        onSuccess: function (data) { return qc.setQueryData(key(collectionId), data); },
    });
};
